import { isAnyArray } from 'is-any-array';
/**
 * Checks if input is of type array
 *
 * @param input - input
 */
export function xCheck(input) {
    if (!isAnyArray(input)) {
        throw new TypeError('input must be an array');
    }
    if (input.length === 0) {
        throw new TypeError('input must not be empty');
    }
}
/**
 * XCheckLengths.
 *
 * @param array1 - First array.
 * @param array2 - Second array.
 */
export function xCheckLengths(array1, array2) {
    if (array1.length !== array2.length) {
        throw new TypeError('Length of array1 and array2 must be identical');
    }
}
//# sourceMappingURL=xCheck.js.map